export enum FAQ_ACTION_TYPES {
    GET_FAQ_START = 'faq/GET_FAQ_START',
    GET_FAQ_SUCCESS = 'faq/GET_FAQ_SUCCESS',
    GET_FAQ_FAILED = 'faq/GET_FAQ_FAILED',
    ADD_FAQ_START = 'faq/ADD_FAQ_START',
    ADD_FAQ_SUCCESS = 'faq/ADD_FAQ_SUCCESS',
    ADD_FAQ_FAILED = 'faq/ADD_FAQ_FAILED',
};